export default () => {


    function checkLoaded() {
        const fades = document.querySelectorAll('[data-fade]');
        const w = window.innerHeight;
        const offset = 0;
        for (const dom of fades) {
            const rect = dom.getBoundingClientRect();
            if (rect.y < w - offset) {
                dom.classList.add('active');
            } else {
                if (parseInt(dom.getAttribute('data-once')) !== 1) {
                    dom.classList.remove('active');
                }
            }
        }
    }



    window.setTimeout(() => {
        checkLoaded();
    }, 500);

    window.addEventListener('scroll', () => {
        checkLoaded()
    }, {
        passive: true
    });

    window.addEventListener('domchanged', () => {
        checkLoaded()
    }, {
        passive: true
    });

    window.addEventListener('ajaxupdated', () => {
        checkLoaded()
    }, {
        passive: true
    });

}
